import { useState, useEffect, useCallback } from "react";

export const getEventKey = (key: string) => `dispatching ${key}`;
export const getLocalStorageData = (key: string) => {
  const json = localStorage.getItem(key);
  const data = json ? JSON.parse(json) : undefined;
  return data;
};
export const useLocalStorage = <T>(
  key: string
): [T | undefined | null, (data: T | undefined | null) => void] => {
  const getData = useCallback(() => {
    const json = localStorage.getItem(key);
    const data = json ? JSON.parse(json) : null;
    return data;
  }, [key]);
  const [data, setData] = useState<T>(getData());

  const eventKey = getEventKey(key);

  const setDataInLocalStorage = useCallback(
    (data: T | undefined | null) => {
      if ((data ?? null) !== null) {
        const json = JSON.stringify(data);
        localStorage.setItem(key, json);
      } else {
        localStorage.removeItem(key);
      }
      window.dispatchEvent(new Event(eventKey));
    },
    [key]
  );

  useEffect(() => {
    const fn = () => {
      const newData = getData();
      setData((data) =>
        JSON.stringify(newData) !== JSON.stringify(data) ? newData : data
      );
    };
    window.addEventListener(eventKey, fn);
    window.addEventListener("storage", fn);
    return () => {
      removeEventListener(eventKey, fn);
      removeEventListener("storage", fn);
    };
  }, [key]);

  useEffect(() => {
    const newData = getData();
    setData((data) =>
      JSON.stringify(newData) !== JSON.stringify(data) ? newData : data
    );
  }, [getData]);

  return [data, setDataInLocalStorage];
};
